/**
 * Flat content section — replaces the boxed Card pattern. A tiny
 * uppercase eyebrow + a hairline divider drawn at the TOP chunks the
 * page without enclosing chrome. The `first:` modifier suppresses
 * both for the very first section under the hero so it doesn't render
 * a leading rule.
 */
export function Section({
  eyebrow,
  adornment,
  children,
}: {
  eyebrow: string;
  /** Right-aligned trailing slot in the section header — used for the
   *  "saving…" indicator on the preferences section. Optional. */
  adornment?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <section className="mt-6 flex flex-col gap-4 border-wx-border border-t pt-5 first:mt-4 first:border-t-0 first:pt-0">
      <div className="flex items-baseline justify-between gap-2">
        <h2 className="text-[11px] font-semibold tracking-[0.08em] text-wx-fg-subtle uppercase">
          {eyebrow}
        </h2>
        {adornment}
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
